"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRuntimeUrl = getRuntimeUrl;
var _ServiceRuntime = require("./types/ServiceRuntime");
const runtimeHierarchy = [_ServiceRuntime.ServiceRuntime.K8s, _ServiceRuntime.ServiceRuntime.VNet, _ServiceRuntime.ServiceRuntime.Public];
function getRuntimeUrl(urlsConfiguration, runtime) {
  if (!urlsConfiguration) {
    return undefined;
  }

  // Return first available url for given runtime based on hierarchy where the rule is: return the most internal address first.
  // E.g. K8s runtime means return k8s address if exists, otherwise return intranet, internal or base address if exists.
  for (let i = runtimeHierarchy.indexOf(runtime); i < runtimeHierarchy.length; i++) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Checked by for loop
    const targetRuntime = runtimeHierarchy.at(i);
    if (targetRuntime === _ServiceRuntime.ServiceRuntime.VNet && runtime === _ServiceRuntime.ServiceRuntime.K8s) {
      // Do not return VNET url for K8s runtime as currently VNET addresses cannot be reached from we aks cluster due to Azure DNS
      // It should be solved in future and VNET addresses should be reachable within Azure DNS
      // TODO (MS): when AKS supports internal addresses, remove this, and also uncomment lines in unit test getRuntimeUrl.test.ts
      continue;
    }
    const url = getRuntimeUrlInternal(urlsConfiguration, targetRuntime);
    if (url) {
      return url;
    }
  }
  return undefined;
}
function getRuntimeUrlInternal(urlsConfiguration, runtime) {
  switch (runtime) {
    // k8sUrl will be removed once intranet url uses nginx + dns instead of WAF
    case _ServiceRuntime.ServiceRuntime.K8s:
      return urlsConfiguration.intranetUrl;
    case _ServiceRuntime.ServiceRuntime.VNet:
      return urlsConfiguration.intranetUrl;
    case _ServiceRuntime.ServiceRuntime.Public:
      return urlsConfiguration.baseUrl;
    default:
      throw new Error(`Unknown runtime: ${runtime}`);
  }
}
//# sourceMappingURL=getRuntimeUrl.js.map